/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { FormGroup } from '@angular/forms'
import isObject from 'lodash-es/isObject'

export const handleFormErrors = (form: FormGroup) => (errors) => {
  if (!errors?.error?.errors) return

  const errorMessages = errors.error.errors[0].detail

  if (typeof errorMessages === 'string') return errorMessages

  if (Array.isArray(errorMessages)) {
    return errorMessages.join('\r\n')
  }

  Object.keys(errorMessages).forEach((field) => {
    if (!form.get(field)) return

    const mergedErrorMessages = Object.values(errorMessages[field]).join('\r\n')
    const errorMessage = isObject(errorMessages[field]) ? mergedErrorMessages : errorMessages[field]
    form.get(field).setErrors({ server: errorMessage })
    form.get(field).markAsTouched()
  })
}
